import { render, staticRenderFns } from "./Petitions.vue?vue&type=template&id=203992b6&scoped=true&"
import script from "./Petitions.vue?vue&type=script&lang=js&"
export * from "./Petitions.vue?vue&type=script&lang=js&"
import style0 from "./Petitions.vue?vue&type=style&index=0&id=203992b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203992b6",
  null
  
)

export default component.exports